import { render } from "./nav-plans-icon.svg?vue&type=template&id=1fa1f750"
import script from "./nav-plans-icon.svg?vue&type=script&lang=js"
export * from "./nav-plans-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1360/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__